import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-386e9f97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "loading" }

import BaseModal from '@/components/BaseModal.vue'
import { COLOR_SET } from '@/styles/variables'
import XMark from '@/styles/icon/XMark.vue'
import CommonLoader from '@/components/common/CommonLoader.vue';


export default /*#__PURE__*/_defineComponent({
  name: 'VideoPlayer',
  props: {
    targetUrl: null
  },
  emits: ["close_modal"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    onClick_overlay: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close_modal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close_modal')))
        }, [
          _createVNode(XMark, {
            color: _unref(COLOR_SET).white
          }, null, 8, ["color"])
        ]),
        _createElementVNode("iframe", {
          src: __props.targetUrl,
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(CommonLoader)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})